export default __webpack_public_path__ + "static/media/clientIcon.a7e7d6e9.svg";